if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
      }
  
      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;
  
        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);
  
 
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('[type="submit"] .spinner').classList.remove('hidden');

    
  
        const formData = new FormData(this.form);
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        // config.body = formData;
 
      
        try {
            const request = await fetch(window.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': "application/json"
                },
                body: formData
            });
            
            if (request.status !== 200) {
                this.handleErrorMessage(request.description);
                return;
            }


            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('loading');
            this.querySelector('[type="submit"] .spinner').classList.add('hidden');
    
            const json = await request.json();
          
          try {
            this.cartNotification.renderContents(json);
          } catch (err) {
           	window.location.reload(true); 
          }


          // Fallback logic.
          let baseProduct;
          const localProduct = this.querySelector("script");
          if (localProduct) {
            baseProduct = JSON.parse(localProduct.innerText);
          } else {
            baseProduct = JSON.parse(document.querySelector("#product-detail").innerText)
          }

          const variant = baseProduct.variants.find(item => item.id === json.variant_id);

          // TODO: refactor out into tracking and trigger event from here.
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              event: "add_to_cart", 
              ecommerce: {
                  currency: window.presentment_currency,
                  value: json.line_price,
                  items: [{
                      item_name: baseProduct.title, // Name or ID is required.
                      item_id: json.sku,
                      price: json.price,
                      item_variant: variant.title,
                      // item_list_name: {{ collection.title | json }},  // If associated with a list selection.
                      // item_list_id: {{ collection.id | json }},  // If associated with a list selection.
                      index: 1,
                      currency: window.presentment_currency,
                      quantity: json.quantity
                  }]
              }
          });

        } catch (err) {
            console.log("Error", err)
        } 
      }
  
      handleErrorMessage(errorMessage = false) {
          return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }